import apiClient from "src/configs/apiClient";
import type { BlobDto } from "src/models/blob.dto";
import {  MyAvatarDto } from "src/models/user.dto";

const UserApi = () => {
    const RemoveAvatarAsync = async () : Promise<void> => {
        await apiClient.delete("/user/me/avatar");
    }

    const UpdateAvatarAsync = async (file: File): Promise<BlobDto> => {
        const formData = new FormData();
        formData.append("file", file);

        const response = await apiClient.put(
            "/user/me/avatar", 
            formData, 
            {headers: { "Content-Type": undefined }
        });

        return response.data.data;
    }

    const GetUserAvatarAsync = async () : Promise<MyAvatarDto | null> => {
        const response = await apiClient.get("/user/me/avatar");
        if (response.status != 200)
            throw new Error("An error occured.");

        return response.data.data;
    }

    return {UpdateAvatarAsync, RemoveAvatarAsync, GetUserAvatarAsync};
}

export default UserApi;
